// import logo from './logo.svg';
import './Footer.css';
import orient_logo from '../../assets/bluelogo.png'
import { AiOutlineTwitter } from 'react-icons/ai'
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { TfiYoutube } from 'react-icons/tfi'
import { TiSocialInstagram } from 'react-icons/ti'
import { useEffect, useState } from 'react';

const product = ['Careers', 'Blog', 'Covid19', 'About us', 'Contact us', 'Delivery','Privacy Policy']
const Company = ['Oral Care', 'Baby Nutrition', 'Herbal Care', 'Mens Health', 'Women Health','Support & Braces']
const support = ['Term of Services', 'Privacy Policy', 'Warranty & Claims', 'Return & Exchange', 'Cancellation Feedback']

function Footer() {
  
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 1100);
  
  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth >= 1100);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
      <footer className="App-header">
        <div className="address_main_div">
          <div style={{ display: 'flex', flexDirection: 'column',  }} className='adress'>
            <img className='orient_icon' src={orient_logo} alt="" />
            <p className='address_1'>
            200-A, SMCHS, Karachi Sindh
            </p>
          </div>
        </div>
        <div className='div_prop_1'>
          <div className='div_prop' >
            <h4 className='headers' >DAWAAI</h4>
            {product?.map((item) => {
              return (
                <p style={{ marginTop: 2 }} className='address'>
                  <a style={{ color: "#777", backgroundColor: 'transparent', borderColor: 'transparent', textDecoration: 'none' }} >{item}</a>
                </p>
              )
            })}
          </div>
          {isWideScreen ? (
            <>
              <div className="column">
                <h4 className='headers'>POPULAR CATEGORIES</h4>
                {Company?.map((item) => {
                  return (
                    <p style={{ marginTop: 2 }} className='address' >
                      <a style={{ color: "#777", backgroundColor: 'transparent', borderColor: 'transparent', textDecoration: 'none' }} href=''>{item}</a>
                    </p>
                  )
                })}
              </div>
              <div className="column2">
                <h4 className='headers'>Support And Services</h4>
                {support?.map((item) => {
                  return (
                    <p style={{ marginTop: 2 }} className='address' >
                      <a style={{ color: "#777", backgroundColor: 'transparent', borderColor: 'transparent', textDecoration: 'none' }} href=''>{item}</a>
                    </p>
                  )
                })}
                <div className='Follow_us'>
                <h4 className='headers'>FOLLOW US</h4>
                  <div className='social_media'>
                    <p><FaFacebookF /></p>
                    <p><AiOutlineTwitter /></p>
                    <p><TfiYoutube /></p>
                    <p><FaLinkedinIn /></p>
                    <p><TiSocialInstagram /></p>
                  </div>
                </div>
              </div>
            </>
          )
            : (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="column">
                  <h4 className='headers'>Dawa</h4>
                  {Company?.map((item) => {
                    return (
                      <p style={{ marginTop: 2 }} className='address'>
                        <a style={{ color: "#777", backgroundColor: 'transparent', borderColor: 'transparent', textDecoration: 'none' }} href='https://example.com'>{item}</a>
                      </p>
                    )
                  })}
                </div>
                <div className="column2">
                  <h4 className='headers'>Support And Services</h4>
                  {support?.map((item) => {
                    return (
                      <p style={{ marginTop: 2 }} className='address'>
                        <a style={{ color: "#777", backgroundColor: 'transparent', borderColor: 'transparent', textDecoration: 'none' }} href='https://example.com'>{item}</a>
                      </p>
                    )
                  })}
                  <div className='Follow_us'>
                    <h4 className="headers">FOLLOW</h4>
                    <div className='social_media'>
                      <p><FaFacebookF /></p>
                      <p><AiOutlineTwitter /></p>
                      <p><TfiYoutube /></p>
                      <p><FaLinkedinIn /></p>
                      <p><TiSocialInstagram /></p>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </footer>
      <div className="last_footer">
        <p style={{ fontSize: 12 }}>
          © 2023 -2023 Dawaai.Pk, All Rights Reserved.
        </p>
      </div>
    </>
  );
}

export default Footer;



